import { render, staticRenderFns } from "./VipReportManager.vue?vue&type=template&id=084ac649&scoped=true"
import script from "./VipReportManager.vue?vue&type=script&lang=js"
export * from "./VipReportManager.vue?vue&type=script&lang=js"
import style0 from "./VipReportManager.vue?vue&type=style&index=0&id=084ac649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ac649",
  null
  
)

export default component.exports